"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProjectDetail = void 0;

var _ProjectInfoChip = _interopRequireDefault(require("../ProjectInfoChip"));

var _CompanyAvatar = _interopRequireDefault(require("../CompanyAvatar"));

var _core = require("@material-ui/core");

var _styles = require("@material-ui/core/styles");

var _reactI18next = require("react-i18next");

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _components = require("../../../components");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: theme.spacing(2)
    },
    divider: {
      backgroundColor: theme.palette.secondary.main,
      height: 3,
      borderRadius: 5,
      width: '30%',
      marginBottom: theme.spacing(2)
    },
    memberAvatar: {
      marginRight: theme.spacing(1),
      width: theme.spacing(7),
      height: theme.spacing(7)
    },
    contentSection: {
      marginBottom: theme.spacing(4)
    },
    keywordChip: {
      marginRight: theme.spacing(2),
      marginBottom: theme.spacing(1),
      paddingLeft: theme.spacing(6),
      paddingRight: theme.spacing(6)
    }
  };
});

var ProjectDetail = function ProjectDetail(_ref) {
  var className = _ref.className,
      title = _ref.title,
      description = _ref.description,
      companyName = _ref.companyName,
      companyPhotoUrl = _ref.companyPhotoUrl,
      companyLink = _ref.companyLink,
      dueDate = _ref.dueDate,
      status = _ref.status,
      amount = _ref.amount,
      members = _ref.members,
      keywords = _ref.keywords,
      props = _objectWithoutProperties(_ref, ["className", "title", "description", "companyName", "companyPhotoUrl", "companyLink", "dueDate", "status", "amount", "members", "keywords"]);

  var classes = useStyles();

  var _useTranslation = (0, _reactI18next.useTranslation)('common'),
      t = _useTranslation.t;

  return /*#__PURE__*/_react.default.createElement(_core.Card, {
    className: (0, _clsx.default)(classes.root, className)
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 2,
    sm: 3,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_CompanyAvatar.default, {
    name: companyName,
    photoUrl: companyPhotoUrl,
    link: companyLink
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 8,
    sm: 7,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentSection
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    gutterBottom: true
  }, title), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body1",
    dangerouslySetInnerHTML: {
      __html: description
    }
  })), (members === null || members === void 0 ? void 0 : members.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentSection
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    gutterBottom: true
  }, t('projects.membersTitle')), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_components.Flex, {
    wrap: true
  }, members.map(function (_ref2) {
    var link = _ref2.link,
        id = _ref2.id,
        photoUrl = _ref2.photoUrl;
    return link ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      key: id,
      to: link
    }, /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.memberAvatar,
      alt: id,
      src: photoUrl
    })) : /*#__PURE__*/_react.default.createElement(_core.Avatar, {
      className: classes.memberAvatar,
      alt: id,
      src: photoUrl
    });
  }))), (keywords === null || keywords === void 0 ? void 0 : keywords.length) > 0 && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.contentSection
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "h3",
    gutterBottom: true
  }, t('projects.keywords')), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_components.Flex, {
    wrap: true
  }, keywords.map(function (i) {
    return /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, {
      key: i,
      className: classes.keywordChip
    }, i);
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    sm: 2,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 2
  }, status && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, status)), dueDate && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, dueDate)), amount && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 4,
    sm: 12
  }, /*#__PURE__*/_react.default.createElement(_ProjectInfoChip.default, null, amount))))));
};

exports.ProjectDetail = ProjectDetail;
ProjectDetail.propTypes = {
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  companyName: _propTypes.default.string,
  companyPhotoUrl: _propTypes.default.string,
  companyLink: _propTypes.default.string,
  dueDate: _propTypes.default.string,
  status: _propTypes.default.string,
  amount: _propTypes.default.string,
  members: _propTypes.default.arrayOf(_propTypes.default.shape({
    link: _propTypes.default.string.isRequired,
    id: _propTypes.default.string.isRequired,
    photoUrl: _propTypes.default.string.isRequired
  })),
  keywords: _propTypes.default.arrayOf(_propTypes.default.string)
};
var _default = ProjectDetail;
exports.default = _default;